"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FbMessenger = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const script_1 = __importDefault(require("next/script"));
const react_1 = require("react");
const env_1 = require("../env");
function FbMessengerComponent() {
    const pageId = (0, env_1.obvioEnv)().OBVIO_PUBLIC_FB_MESSENGER_ID;
    return pageId ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { id: "fb-root" }), (0, jsx_runtime_1.jsx)("div", { id: "fb-customer-chat", className: "fb-customerchat" })] }), (0, jsx_runtime_1.jsx)(script_1.default, Object.assign({ id: "facebook-messenger", strategy: "afterInteractive", async: true }, { children: `
          var chatbox = document.getElementById('fb-customer-chat');
          chatbox.setAttribute('page_id', '${pageId}');
          chatbox.setAttribute('attribution', 'biz_inbox');

          window.fbAsyncInit = function() {
            FB.init({ xfbml: true, version: 'v19.0' });
          };

          (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = 'https://connect.facebook.net/pl_PL/sdk/xfbml.customerchat.js';
            fjs.parentNode.insertBefore(js, fjs);
          }(document, 'script', 'facebook-jssdk'));
        ` }))] })) : null;
}
exports.FbMessenger = (0, react_1.memo)(FbMessengerComponent);
